var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"catalog-container"},[_c('img',{attrs:{"src":require("./assets/catalogInit.svg")}}),_c('div',{staticClass:"description"},[_c('div',{staticClass:"label"},[_vm._v("您还未设置关键目录，快去设置吧~")]),_c('el-button',{attrs:{"type":"primary","size":"small"},on:{"click":_vm.goto}},[_vm._v("去设置")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }